<template v-if="loaded">
  <f7-page @page:beforein="beforein">
    <navbar :text="`${$t('Configuration.name')} > ${$t('Configuration.Tasks_Title')}`" />
    <TasksDatabase
      :task-definitions="taskDefinitions"
    />
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import TasksDatabase from '../../../components/configuration/tasks/tasksDatabase/index.vue';
import navbar from '../../../components/NavBar.vue';

export default {
  name: 'Tasks',
  components: {
    TasksDatabase,
    navbar,
  },

  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    ...mapState('TaskDefinition', ['taskDefinitions']),

  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      await this.getTaskDefinitionsConfig();
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t(`${error}`),
          width: 550,
        },
        'error',
        3000,
      );
    } finally {
      this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  methods: {
    beforein() {
      this.$fa.setScreenName('Configuración > Tareas');
    },
    ...mapActions('TaskDefinition', ['getTaskDefinitionsConfig']),
  },
};
</script>
